import { render, staticRenderFns } from "./YourCustomTreatment.vue?vue&type=template&id=12479c55&scoped=true&"
import script from "./YourCustomTreatment.vue?vue&type=script&lang=js&"
export * from "./YourCustomTreatment.vue?vue&type=script&lang=js&"
import style0 from "./YourCustomTreatment.vue?vue&type=style&index=0&id=12479c55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12479c55",
  null
  
)

export default component.exports